module.exports = {
	"signup": {
		"main": {
			"not_possible_create_account": "Não foi possível criar sua conta, tente novamente!",
			"create_account": "Criar conta",
			"creating_account": "Criando conta...",
			"person_data": "Dados pessoais",
			"name": "Nome",
			"fill_username": "Preencha o nome do usuário",
			"cpf": "CPF",
			"required_cpf": "Preencha o CPF",
			"invalid_cpf": "CPF inválido",
			"contact_type": "Tipo de contato",
			"residential": "Residencial",
			"cellphone": "Celular",
			"business": "Empresarial",
			"select_contact_type": "Selecione o tipo de contato",
			"phone_number": "Número do telefone",
			"phone": "Telefone",
			"fill_valid_phone_number": "Preencha um número de telefone válido",
			"account_type": "Tipo de conta",
			"personal_account": "Pessoal",
			"customer_account": "Empresarial",
			"choose_account_type": "Escolha o tipo de cadastro",
			"company_data": "Dados da empresa",
			"fantasy_name": "Nome fantasia",
			"fill_fantasy_name": "Preencha o nome fantasia",
			"cnpj": "CNPJ",
			"report_valid_cnpj": "Informe um CNPJ",
			"invalid_cnpj": "CNPJ inválido",
			"address": "Endereço",
			"postal_code": "CEP",
			"report_postal_code_valid": "Informe um CEP válido",
			"postal_code_not_found": "Endereço não encontrado",
			"street": "Rua",
			"fill_street": "Preencha a rua",
			"address_number": "Número",
			"fill_address_number": "Preencha o número do endereço",
			"neighborhood": "Bairro",
			"fill_neighborhood": "Preencha o bairro",
			"complement": "Complemento",
			"city": "Cidade",
			"fill_city": "Preencha a cidade",
			"state": "Estado",
			"choose_state": "Escolha o estado",
			"access_data": "Dados de acesso",
			"mail": "E-mail",
			"fill_mail": "Preencha o E-mail",
			"password": "Senha",
			"fill_password": "Preencha a senha",
			"login": "Login"
		},
		"placeholder": {
			"fill_full_name": "Ex.: João da Silva",
			"cpf": "Ex.: 123.456.789-00",
			"phone": "Ex.: (11) 3311-8700",
			"cnpj": "Ex.: 27.517.341/0001-95",
			"postal_code": "Ex.: 00000-000",
			"street_avenue": "Ex.: Rua/Av. Capitão Macedo",
			"neighborhood_example": "Ex.: Bairro da luz",
			"optional": "Opcional",
			"your_city": "Ex.: Marília",
			"mail_example": "Ex.: seuemail@exemplo.com",
			"choose_password": "Ex.: 1234",
			"number": "Ex.: 1234",
			"trade_name": "Ex.: Minha empresa LTDA",
			"contact": {
				"area_code": "14"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/signup/pt-BR.yml
// module id = 593
// module chunks = 1